import Http from '@/services/http';
import translate from '@/services/translate';
import {
  NormLookup,
  MethodsLookupResponse,
  MethodsParametersTable,
  rulesMap,
  parametersMethodsMap,
  potencyLimitsMap,
  DuvalMethodParameterResponse,
  DuvalMethodParameterRequest,
} from 'sigma-mappings';
import invert from 'lodash/invert';

const urls = {
  getParametersTable: (assetModuleId, params) => `/engenharia/${assetModuleId}/cromatografia/normas/${params.norm}/metodos/${params.method}/parametros`,
  getParametersTableLimited: (assetModuleId, params) => `/engenharia/${assetModuleId}/cromatografia/normas/${params.norm}/metodos/${params.method}/parametros-padroes?limitePotencia=${params.limit}`,
  editParameters: (assetModuleId, params) => `/engenharia/${assetModuleId}/cromatografia/normas/${params.norm}/metodos/${params.method}/parametros`,
  lookupNorms: '/engenharia/cromatografia/normas',
  lookupMethod: (assetModuleId, norm) => `/engenharia/${assetModuleId}/cromatografia/normas/${norm}/metodos`,
  duvalParameter: (assetModuleId, method) => `/engenharia/${assetModuleId}/cromatografia/normas/duval/metodos/${method}/parametros`,
  showParameter: (assetModuleId, params) => `/engenharia/${assetModuleId}/cromatografia/normas/${params.norm}/metodos/${params.method}/exibir`,
  hideParameter: (assetModuleId, params) => `/engenharia/${assetModuleId}/cromatografia/normas/${params.norm}/metodos/${params.method}/ocultar`,
  getTreetechMethodologyPaper: '/engenharia/cromatografia/normas/duval/metodologia-treetech',
};
const fields = {
  Norma: {
    name: 'engineering.norm',
  },
  Metodo: {
    name: 'engineering.method',
  },
};

const duvalErrors = {
  errorHandling: {
    responseMessageParams: {
      $MA071: data => data,
      $MA001: ({ field }) => {
        const returnedField = fields[field];
        if (!returnedField) return null;
        return {
          NomeDoCampo: translate(returnedField.name),
        };
      },
    },
  },
};

export default {
  getNormsLookup() {
    const http = new Http();
    return http
      .get(urls.lookupNorms)
      .then(({ data }) => data.map(item => new NormLookup(item)));
  },
  getMethodsLookup(assetModuleId, params) {
    const norm = invert(rulesMap)[params.norm];
    const http = new Http();
    return http
      .get(urls.lookupMethod(assetModuleId, norm))
      .then(({ data }) => data.map(item => new MethodsLookupResponse(item)));
  },
  getParametersTable(assetModuleId, params) {
    const mappedParams = {
      norm: invert(rulesMap)[params.norm],
      method: invert(parametersMethodsMap)[params.method],
    };
    const http = new Http();
    return http
      .get(urls.getParametersTable(assetModuleId, mappedParams))
      .then(({ data }) => new MethodsParametersTable(data));
  },
  getParametersTableLimited(assetModuleId, params) {
    const mappedParams = {
      norm: invert(rulesMap)[params.norm],
      method: invert(parametersMethodsMap)[params.method],
      limit: invert(potencyLimitsMap)[params.limit],
    };
    const http = new Http();
    return http
      .get(urls.getParametersTableLimited(
        assetModuleId,
        mappedParams,
      ))
      .then(({ data }) => new MethodsParametersTable(data));
  },
  editParametersTable(assetModuleId, params) {
    const mappedParams = {
      norm: invert(rulesMap)[params.norm],
      method: invert(parametersMethodsMap)[params.method],
    };
    const mappedPayload = new MethodsParametersTable.MapBack(params.payload);
    const http = new Http();
    return http.put(
      urls.editParameters(assetModuleId, mappedParams),
      mappedPayload,
    ).then(({ data }) => data);
  },
  handleVisibility(assetModuleId, params) {
    const mappedParams = {
      ...params,
      norm: invert(rulesMap)[params.norm],
      method: invert(parametersMethodsMap)[params.method],
    };
    const http = new Http();
    const url = mappedParams.hidden ? urls.showParameter : urls.hideParameter;
    return http
      .put(url(assetModuleId, mappedParams))
      .then(({ data }) => data);
  },
  getDuvalParameters(assetModuleId, method) {
    const http = new Http();
    const mappedMethod = invert(parametersMethodsMap)[method];
    return http.get(urls.duvalParameter(assetModuleId, mappedMethod))
      .then(({ data }) => new DuvalMethodParameterResponse(data));
  },
  editDuvalParameters(assetModuleId, method, payload) {
    const http = new Http(duvalErrors);
    const mappedMethod = invert(parametersMethodsMap)[method];
    const mappedPayload = new DuvalMethodParameterRequest(payload);
    return http.put(urls.duvalParameter(assetModuleId, mappedMethod), mappedPayload)
      .then(({ data }) => data);
  },
  getTreetechMethodologyPaper() {
    const http = new Http({ download: true });
    return http.get(urls.getTreetechMethodologyPaper);
  },
};
